import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import FilterRadioButton from '../../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../components/FilterRadioButtonsContainer';
import FormGroup from '../../../components/FormGroup';
import Input from '../../../components/Input';
import { GetErrorMessageByFieldNameType } from '../../../hooks/useErrors';

interface BillingAddressInterface {
  getErrorMessageByFieldName: GetErrorMessageByFieldNameType;
  billingAddress: string;
  setBillingAddres: Dispatch<SetStateAction<string>>;
  isGettingBillingCepData: boolean;
  billingCep: string;
  handleBillingCepChange: (event: ChangeEvent<HTMLInputElement>) => void;
  billingUf: string;
  billingCity: string;
  billingDistrict: string;
  billingStreet: string;
  handleBillingNumberChange: (event: ChangeEvent<HTMLInputElement>) => void;
  billingNumber: string | number;
  handleBillingComplementChange: (event: ChangeEvent<HTMLInputElement>) => void;
  billingComplement: string;
  billingMustFillManualy: boolean;
  handleBillingDistrictChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleBillingStreetChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export default function BillingAddress({
  billingAddress,
  setBillingAddres,
  getErrorMessageByFieldName,
  isGettingBillingCepData,
  billingCep,
  handleBillingCepChange,
  billingUf,
  billingCity,
  billingDistrict,
  billingStreet,
  handleBillingNumberChange,
  billingNumber,
  handleBillingComplementChange,
  billingComplement,
  billingMustFillManualy,
  handleBillingDistrictChange,
  handleBillingStreetChange,
}: BillingAddressInterface) {
  return (
    <div className="dataGroup">
      <div className="title">
                3. Endereço de faturamento
        <FilterRadioButtonsContainer>
          <FilterRadioButton
            selected={billingAddress === 'same'}
            onClick={() => setBillingAddres('same')}
          >
                    Mesmo da empresa
          </FilterRadioButton>
          <FilterRadioButton
            selected={billingAddress === 'another'}
            onClick={() => setBillingAddres('another')}
          >
                    Outro
          </FilterRadioButton>
        </FilterRadioButtonsContainer>
      </div>

      {billingAddress === 'another' && (
        <>
          <div className="aside">
            <div className="loginInput">
              <FormGroup error={getErrorMessageByFieldName('billingCep')} isLoading={isGettingBillingCepData}>
                <label htmlFor="login">CEP</label>
                <Input
                  disabled={isGettingBillingCepData}
                  placeholder="Informe o CEP"
                  value={billingCep}
                  onChange={handleBillingCepChange}
                  autoComplete="new-password"
                  maxLength={9}
                  error={getErrorMessageByFieldName('billingCep')}
                />
              </FormGroup>
            </div>
            <div className="loginInput">
              <FormGroup isLoading={isGettingBillingCepData}>
                <label htmlFor="login">UF</label>
                <Input
                  disabled
                  placeholder="Preenchido automaticamente"
                  value={billingUf}
                  autoComplete="new-password"
                />
              </FormGroup>
            </div>

          </div>

          <div className="aside">
            <div className="loginInput">
              <FormGroup isLoading={isGettingBillingCepData}>
                <label htmlFor="login">Cidade</label>
                <Input
                  disabled
                  placeholder="Preenchido automaticamente"
                  value={billingCity}
                  autoComplete="new-password"
                />
              </FormGroup>
            </div>
            <div className="loginInput">
              <FormGroup isLoading={isGettingBillingCepData}>
                <label htmlFor="login">Bairro</label>
                <Input
                  disabled={!billingMustFillManualy}
                  placeholder="Preenchido automaticamente"
                  value={billingDistrict}
                  autoComplete="new-password"
                  onChange={handleBillingDistrictChange}
                />
              </FormGroup>
            </div>
            <div className="loginInput">
              <FormGroup isLoading={isGettingBillingCepData}>
                <label htmlFor="login">Logradouro</label>
                <Input
                  disabled={!billingMustFillManualy}
                  placeholder="Preenchido automaticamente"
                  value={billingStreet}
                  autoComplete="new-password"
                  onChange={handleBillingStreetChange}
                />
              </FormGroup>
            </div>
          </div>

          <div className="aside">
            <div className="loginInput">
              <FormGroup error={getErrorMessageByFieldName('billingNumber')}>
                <label htmlFor="login">Número</label>
                <Input
                  onChange={handleBillingNumberChange}
                  placeholder="Caso não tenha, preencha 0"
                  value={billingNumber}
                  autoComplete="new-password"
                  error={getErrorMessageByFieldName('billingNumber')}
                />
              </FormGroup>
            </div>
            <div className="loginInput">
              <FormGroup>
                <label htmlFor="login">Complemento</label>
                <Input
                  onChange={handleBillingComplementChange}
                  placeholder="Complemento"
                  value={billingComplement}
                  maxLength={20}
                  autoComplete="new-password"
                />
              </FormGroup>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
